const state = {
  list: [],         //分期列表
  cur: {},         // 当前cur
  curIndex: null,
  visible: false
}
const mutations = {
  SET_INFO_KEY: (state, data) => {     //设置值
    const { key, value } = data;
    state[key] = value
  },
  REMOVE_INFO: (state, data) => {
    state.list.splice(data, 1)
  },
  Add: (state, data) => {
    state.list.push(data)
  }
}
const actions = {
  async reMove({ commit }, data) {      //删除
    commit("REMOVE_INFO", data)
  },
  async setInfokey({ commit }, data) {
    commit("SET_INFO_KEY", data)
  },
  async add({ commit }, data) {
    commit("Add", data)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}